module.exports = __webpack_public_path__ + "img/calendar-mobile.1afe6b68.svg";